import * as ko from 'knockout';

const template = require('raw-loader!../../templates/unit_groups.html').default;

/** Mount point for the React unit groups section inside the Knockout shell. */
class UnitGroupsScreen {}

export const unitGroups = { name: 'unit-groups', viewModel: UnitGroupsScreen, template: template };

ko.components.register(unitGroups.name, unitGroups);
